module.exports = __webpack_public_path__ + "static/media/screenshot1.298e978f.png";